import React, { createContext, useContext, useState, useCallback } from 'react'

interface ApplicationSurveyContextType {
  isSurveyVisible: boolean
  manageSurveyVisibility: (newState?: boolean) => void
}

const ApplicationSurveyContext = createContext<ApplicationSurveyContextType>({
  isSurveyVisible: true,
  manageSurveyVisibility: () => {},
})

const useApplicationSurvey = (): ApplicationSurveyContextType => {
  const context = useContext(ApplicationSurveyContext)
  if (context === undefined) {
    throw new Error('useApplicationSurvey is not available')
  }
  return context
}
const ApplicationSurveyProvider = ({ children }: { children: any }) => {
  const [isSurveyVisible, setIsSurveyVisible] = useState<boolean>(true)
  const manageSurveyVisibility = useCallback(
    (isVisible?: boolean) => {
      setIsSurveyVisible(prev => isVisible ?? !prev)
    },
    [isSurveyVisible]
  )

  const contextValue: ApplicationSurveyContextType = {
    isSurveyVisible,
    manageSurveyVisibility,
  }

  return (
    <ApplicationSurveyContext.Provider value={contextValue}>
      {children}
    </ApplicationSurveyContext.Provider>
  )
}

export {
  ApplicationSurveyContext,
  ApplicationSurveyProvider,
  useApplicationSurvey,
}
